import {
  Box,
  Button,
  createStyles,
  Group,
  Modal,
  Radio,
  Select,
  Text,
  TextInput,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { IconChevronDown } from "@tabler/icons-react";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import swal from "sweetalert";
import {
  editConsumer,
  getAllBillingConsumers,
} from "../../../services/billinginvoice";
import { stateZipCodes } from "../../../utils/zipCodes";

const useStyles = createStyles(() => ({
  addbox: {
    padding: "12px 12px 20px 30px",
    borderRadius: "12px",
    border: "1px solid #E5E5EA",
    background: "#FFF",
  },

  formRow: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "20px",
    "@media (max-width:1300px)": {
      // flexDirection: "column",
      // gap: "10px",
    },

    mt19: {
      marginTop: "19px",
    },

    boxtype: {
      display: "flex",
      flexDirection: "row",
    },
  },
  selectnumber: {
    width: "120px",
    padding: "5px 15px",
    borderRadius: "5px",
    backgroundColor: bgColor,
    // width: "50%",
    "& input": {
      backgroundColor: "transparent",
      border: "none",
      paddingInline: 0,
    },
  },

  selectbilling: {
    width: "70px",
    padding: "5px 5px",
    borderRadius: "5px",
    backgroundColor: bgColor,
    // width: "50%",
    "& input": {
      backgroundColor: "transparent",
      border: "none",
      paddingInline: 0,
    },
  },

  selecttext: {
    width: "120px",
    padding: "5px 15px",
    borderRadius: "5px",
    backgroundColor: bgColor,
    "& input": {
      backgroundColor: "transparent",
      border: "none",
      paddingInline: 0,
    },
  },

  line: {
    width: "2px",
    height: "42.011px",
    background: "#525252",
  },

  dflex: {
    display: "flex",
    justifyContent: "space-between",
  },

  flexend: {
    display: "flex",
    justifyContent: "flex-end",
  },

  addbtn: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: "8px",
  },

  boxnumber: {
    display: "flex",
    flexDirection: "row",
    // width:'100%'
    // width: "min-content",
    // justifyContent:'flex-end'
  },

  radiobox: {
    color: "#000",
    fontFamily: "Inter",
    fontSize: "12px",
    fontWeight: 500,
  },

  datePicker: {
    width: "40%",
    "& .mantine-InputWrapper-label": {
      marginLeft: 10,
    },
    "& .mantine-DatePickerInput-input": {
      borderRadius: 8,
      border: "1px solid #D4D4D4",
      background: "#FFF",
      boxShadow:
        "0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #F2F4F7",
    },
  },

  itembox: {
    borderRadius: 8,
    border: "1px solid #E5E5E5",
    background: "#FCFCFC",
    padding: "20px",
    width: "100%",
  },

  recurringbox: {
    marginTop: "24px",
    marginBottom: "24px",
    background: "#f2f2f2",
    borderRadius: "8px",
    border: "1px solid #E5E5E5",
    display: "flex",
    justifyContent: "center",
    gap: "72px",
    alignItems: "center",
    margin: "auto",
    padding: "6px 13px",
  },

  recuuringselect: {
    marginTop: "20px",
    marginBottom: "20px",
    justifyContent: "center",
    display: "flex",
  },
}));
const bgColor = "#D9D9D9";

const CustomTextInput = ({ ...rest }) => {
  const useStyles = createStyles((theme) => ({
    textInputBox: {
      width: "300px",
      padding: "5px 15px",
      borderRadius: "5px",
      backgroundColor: bgColor,
      "& input": {
        backgroundColor: "transparent",
        border: "none",
        paddingInline: 0,
      },
    },
  }));
  const { classes } = useStyles();

  return (
    <div className={classes.textInputBox}>
      <TextInput {...rest} />
    </div>
  );
};

const CustomSelectBox = ({ ...rest }) => {
  const useStyles = createStyles((theme) => ({
    textInputBox: {
      width: "300px",
      padding: "5px 11px",
      borderRadius: "5px",
      backgroundColor: bgColor,
      "& input": {
        border: "none",
        paddingInline: 0,
        backgroundColor: "transparent",
      },
    },
  }));
  const { classes } = useStyles();

  return (
    <div className={classes.textInputBox}>
      <Select
        {...rest}
        rightSection={<IconChevronDown color={"#FBAA0D"} size={20} />}
        rightSectionWidth={25}
        styles={{ rightSection: { pointerEvents: "none" } }}
      />
    </div>
  );
};

const EditConsumer = ({
  editcustomer,
  setEditcustomer,
  customer,
  setCustomer,
  isPreview,
  setIsPreview,
}) => {
  console.log("🚀 ~ editcustomer:", editcustomer)
  const [currentStep, setCurrentStep] = useState(0);
  const { profile } = useSelector((state) => state?.profile);

  const { classes } = useStyles();

  const [status, setStatus] = useState(customer?.status || "active");

  // console.log("customer", customer);

  const handleRadioChange = (value) => {
    setStatus(value);
  };

  const form = useForm({
    initialValues: {
      name: "",
      email: "",
      phone: "",
      address: "",
    },
  });

  const renderContent = () => {
    switch (currentStep) {
      case 0:
        return (
          <>
            <form>
              <Box className={classes.addbox}>
                <div className={classes.formRow}>
                  <Box>
                    <Text ff={"Inter"} fz={15} fw={500} color="#262626">
                      Customer Name
                    </Text>
                    <Box className={classes.boxnumber}>
                      <CustomTextInput
                        id="invoice-Number"
                        // label={"Facility Name"}
                        required
                        size="sm"
                        placeholder={"Enter Customer Name"}
                        // placeholder={"Enter Medication Name"}
                        // {...form.getInputProps("medicationName")}
                        withAsterisk
                        {...form.getInputProps("name")}
                        disabled={isPreview}
                      />

                      {/* <Box className={classes.line}></Box> */}
                    </Box>
                  </Box>

                  <Box>
                    <Text ff={"Inter"} fz={15} fw={500} color="#262626">
                      Customer Email
                    </Text>
                    <Box className={classes.boxnumber}>
                      <CustomTextInput
                        id="invoice-Number"
                        required
                        // label={"Facility Name"}
                        size="sm"
                        placeholder={"Enter Customer Email"}
                        // placeholder={"Enter Medication Name"}
                        // {...form.getInputProps("medicationName")}
                        withAsterisk
                        {...form.getInputProps("email")}
                        disabled={isPreview}
                      />

                      {/* <Box className={classes.line}></Box> */}
                    </Box>
                  </Box>
                </div>

                <div className={classes.formRow}>
                  <Box>
                    <Text ff={"Inter"} fz={15} fw={500} color="#262626">
                      Customer Address
                    </Text>
                    <Box className={classes.boxnumber}>
                      <CustomTextInput
                        id="invoice-Number"
                        required
                        // label={"Facility Name"}
                        size="sm"
                        placeholder={"Enter Customer Address"}
                        // placeholder={"Enter Medication Name"}
                        // {...form.getInputProps("medicationName")}
                        withAsterisk
                        {...form.getInputProps("address")}
                        disabled={isPreview}
                      />

                      {/* <Box className={classes.line}></Box> */}
                    </Box>
                  </Box>

                  <Box>
                    <Text ff={"Inter"} fz={15} fw={500} color="#262626">
                      Customer Phone
                    </Text>
                    <Box className={classes.boxnumber}>
                      <CustomTextInput
                        id="invoice-Number"
                        // label={"Facility Name"}
                        required
                        size="sm"
                        placeholder={"Enter Customer Phone"}
                        // placeholder={"Enter Medication Name"}
                        // {...form.getInputProps("medicationName")}
                        withAsterisk
                        {...form.getInputProps("phone")}
                        disabled={isPreview}
                      />

                      {/* <Box className={classes.line}></Box> */}
                    </Box>
                  </Box>
                </div>

                <div className={classes.formRow}>
                  <Box>
                    <Text ff={"Inter"} fz={15} fw={500} color="#262626">
                      Customer Address 2
                    </Text>
                    <Box className={classes.boxnumber}>
                      <CustomTextInput
                        id="invoice-Number"
                        required
                        // label={"Facility Name"}
                        size="sm"
                        placeholder={"Enter Customer Address"}
                        // placeholder={"Enter Medication Name"}
                        // {...form.getInputProps("medicationName")}
                        withAsterisk
                        {...form.getInputProps("address2")}
                        // disabled={isPreview}
                      />

                      {/* <Box className={classes.line}></Box> */}
                    </Box>
                  </Box>

                  <Box>
                    <Text ff={"Inter"} fz={15} fw={500} color="#262626">
                      Customer City *
                    </Text>
                    <Box className={classes.boxnumber}>
                      <CustomTextInput
                        id="invoice-Number"
                        // label={"Facility Name"}
                        required
                        size="sm"
                        placeholder={"Enter Customer Phone"}
                        // placeholder={"Enter Medication Name"}
                        // {...form.getInputProps("medicationName")}
                        withAsterisk
                        {...form.getInputProps("city")}
                        // disabled={isPreview}
                      />

                      {/* <Box className={classes.line}></Box> */}
                    </Box>
                  </Box>
                </div>

                <div className={classes.formRow}>
                  <Box>
                    <Text ff={"Inter"} fz={10} fw={400} color="#737373">
                      Customer State
                    </Text>

                    <CustomSelectBox
                      id="state"
                      size="sm"
                      withAsterisk
                      data={Array.from(
                        new Set(stateZipCodes?.map((obj) => obj.ste_name))
                      )?.map((ste_name) => ({
                        value: ste_name,
                        label: ste_name,
                      }))}
                      {...form.getInputProps("state")}
                      searchable
                    />
                  </Box>

                  <Box>
                    <Text ff={"Inter"} fz={10} fw={400} color="#737373">
                      Customer Zip Code
                    </Text>

                    <CustomSelectBox
                      id="zip-code"
                      type="number"
                      size="sm"
                      withAsterisk
                      disabled={!form?.values?.state}
                      data={
                        form?.values?.state
                          ? stateZipCodes
                              ?.filter(
                                (obj) => obj?.ste_name === form?.values?.state
                              )
                              ?.map((obj) => ({
                                value: obj?.zip_code,
                                label: obj?.zip_code,
                              }))
                          : []
                      }
                      {...form.getInputProps("zipcode")}
                      searchable
                    />
                  </Box>
                </div>

                <div className={classes.formRow}>
                  <Box>
                    <Text ff={"Inter"} fz={15} fw={500} color="#262626">
                      Status
                    </Text>
                    <Group>
                      <Radio
                        className={classes.radiobox}
                        checked={status === "active"}
                        onChange={() => handleRadioChange("active")}
                        disabled={isPreview}
                        label="Active"
                        value="active"
                      />
                      <Radio
                        className={classes.radiobox}
                        label="non-Active"
                        value="non-active"
                        disabled={isPreview}
                        checked={status === "non-active"}
                        onChange={() => handleRadioChange("non-active")}
                      />
                    </Group>
                  </Box>
                </div>
                <Box
                  style={{ marginTop: "20px", marginBottom: "20px" }}
                  className={classes.dflex}
                >
                  <Button
                    variant="filled"
                    onClick={handleClose}
                    c={"#000"}
                    style={{ width: "40%" }}
                    // className={classes.backNextBtn}
                    color="gray"
                    size="md"
                  >
                    Back
                  </Button>

                  <Button
                    onClick={onSave}
                    variant="filled"
                    style={{ width: "40%" }}
                    c={"#000"}
                    radius={"md"}
                    size="md"
                    color="yellow"
                    // className={classes.backNextBtn}
                  >
                    Update
                  </Button>
                </Box>
              </Box>
            </form>
          </>
        );

      default:
        return null;
    }
  };

  const onSave = async () => {
    const values = form.values;

    const emptyField = Object.values(values).some(
      (value) => value === "" || value === null
    );

    if (emptyField) {
      swal({
        title: "Error",
        text: "All fields are required.",
        icon: "error",
        dangerMode: true,
      });
      return false;
    }

    // console.log('values',values);
    // console.log('customer',customer);

    let payload = {
      ...values,
      admin: profile.user.id,
      status,
      consumerId:customer?.consumerId,
      id: customer.id,
      lastPaymentDate: customer?.lastPaymentDate,
      totalReceivables: customer?.totalReceivables,
    };

    const res = await editConsumer(payload);

    //   // await updatestate(res);

    if (res.status === 200) {
      let payload ={
        page:1
      }
      getAllBillingConsumers(payload);
      swal({
        title: `Consumers Updated successfully`,
        text: "Consumers Updated successfully",
        dangerMode: false,
      });
      form?.reset();
      setCustomer(null);
      handleClose();
    }

    // console.log("payload", payload);
  };

  useEffect(() => {
    if (customer) {
      form.setValues({
        name: customer?.name || "",
        email: customer?.email || "",
        phone: customer?.phone || "",
        address: customer?.address || "",
        address2: customer?.address2 || "",
        state: customer?.state || "",
        city: customer?.city || "",
        zipcode: String(customer?.zipcode) || "",
      });
    }
  }, [customer]);

  const handleClose = () => {
    setEditcustomer(false);
    setIsPreview(false);
  };

  return (
    <Modal
      opened={editcustomer}
      size={1000}
      title="Edit Consumer"
      shadow="md"
      onClose={handleClose}
      overlayProps={{ blur: 3 }}
      radius={"lg"}
      zIndex={1000}
      centered
    >
      <Box>{renderContent()}</Box>
    </Modal>
  );
};

export default EditConsumer;
